import Vue from 'vue'

const state = {
  masterTemplate: [],
  template: [],
  templates: [],
  assignTemplateValues: {
    templateID: '',
    userID: '',
    locationID: ''
  }
}

const mutations = {
  SET_MASTER_TEMPLATE({
    commit
  }, value) {
    state.masterTemplate = value
  },
  SET_TEMPLATES({
    commit
  }, value) {
    state.templates = value || []
  },
  ADD_TEMPLATE({
    commit
  }, value) {
    let index = state.templates.findIndex(x => {
      return x.ID === value.ID
    })
    if (index > -1) {
      state.templates[index] = value
    } else {
      state.templates.unshift(value)
    }
  },
  DELETE_TEMPLATE({
    commit
  }, template) {
    state.templates.splice(state.templates.indexOf(template), 1)
  }
}

const actions = {
  getMasterTemplate({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}auditTemplate/getmaster`)
        .then(response => {
          commit('SET_MASTER_TEMPLATE', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTemplates({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}auditTemplate/getbylocation`)
        .then(response => {
          commit('SET_TEMPLATES', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  upsertTemplate({
    commit
  }, {
    id,
    name,
    template,
    isActive,
    locationID
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}auditTemplate/upsert`, {
        id: id,
        name: name,
        locationID: locationID,
        isActive: isActive,
        template: template
      })
        .then(response => {
          commit('ADD_TEMPLATE', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createTemplate({
    commit
  }, {
    name,
    template,
    locationID
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}auditTemplate/create`, {
        name: name,
        locationID: locationID,
        template: template
      })
        .then(response => {
          commit('ADD_TEMPLATE', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteTemplate({
    commit
  }, template) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}audittemplate/delete`, {
        ID: template.ID
      })
        .then(response => {
          if (response) {
            commit('DELETE_TEMPLATE', template)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getters = {
  masterTemplate() {
    // Group by section name
    // Resource: https://goo.gl/hlpGx
    return state.masterTemplate
      .reduce((acc, item) => {
        var key = item.SectionName
        acc[key] = acc[key] || []
        acc[key].push(item)
        return acc
      }, {})
  },
  template() {
    return state.template
  },
  templates() {
    return state.templates
  },
  assignTemplateValues() {
    return state.assignTemplateValues
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/templates.js